// src/actions/cartActions.js

export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const DECREASE_QUANTITY = 'DECREASE_QUANTITY';
export const SET_OPCIONES_PRODUCTO = 'SET_OPCIONES_PRODUCTO';

export const addToCart = (product, quantity) => ({
  type: ADD_TO_CART,
  payload: { product, quantity },
});

export const removeFromCart = (productId) => ({
  type: REMOVE_FROM_CART,
  payload: { productId },
});

export const decreaseQuantity = (productId) => ({
  type: DECREASE_QUANTITY,
  payload: { productId },
});

export const setOpcionesProducto = (productId, banda, tipo) => ({
  type: SET_OPCIONES_PRODUCTO,
  payload: { productId, banda: banda || '', tipo: tipo || '' },
});
